import { startTransition, useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { BUN_PREVIEW } from "../bunPreview";

const householdFromPath = (path) => path?.match(/^\/crm\/households\/([^/]+)\//)?.[1];

/**
 * Returns a navigation setter that triggers a history.push on the next render.
 * Useful for imperative navigation from event handlers without direct router access.
 * @returns {Function} navigate - Call with a path string to navigate (e.g. navigate("/dashboard"))
 */
const useNav = () => {
  const [nav, setNav] = useState(null); // State to store the navigation request
  const history = useHistory(); // Access the browser's history object
  const navigate = useCallback((to, options = {}) => {
    setNav({ to, options });
  }, []);

  useEffect(() => {
    if (nav) {
      // Trigger navigation only when 'nav' has a value
      const { to, options = {} } = nav;
      const navigate = () => {
        if (options.replace) {
          history.replace(to, options.state);
        } else {
          history.push(to, options.state);
        }
      };
      const householdId = householdFromPath(history.location.pathname);
      const destinationHouseholdId = householdFromPath(typeof to === 'string' ? to : to?.pathname);
      if (BUN_PREVIEW && householdId && householdId !== 'smart-table' && householdId === destinationHouseholdId) {
        // Keep the current household visible while an unwarmed tab (including
        // nested lazy workspaces) loads instead of revealing the app fallback.
        startTransition(navigate);
      } else {
        navigate();
      }
    }
    setNav(null); // Reset 'nav' to null after navigation
  }, [history, nav]); // Trigger the effect when 'history' or 'nav' changes

  return navigate; // Return a function to set the navigation request
};

export default useNav;
